import { useEffect } from "react";
import keyboardState from "../state/keyboard.state";

export const KeyboardController = () => {
    
  const keyPress = (key, eventKey) => {
    if (key.key === eventKey && keyboardState.press_key === "") {
      /// левый CTRL
      console.log("Нажал", eventKey);
      keyboardState.setParameters("press_key", key.key);
    }
  };

  useEffect(() => {
    const handleKeyDown = (key) => {
      keyPress(key, "Control");
    };
    const handleKeyUp = () => {
      keyboardState.setParameters("press_key", "");
    };
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
};
